import './text-input-group.less';
import {
  asPromise,
  boolOr,
  classNames,
  hasText,
} from "utils/helpers";
import FlexContainer from "../flex-container";
import {SyntheticEvent, useState } from 'react';

export type TextInputProps = {
  id: string
  className?: string
  label?: string
  value: string
  placeholder?: string
  onChange: (value: string) => void|Promise<void>
  validationError: string|null
  disabled?: boolean
  prefix?: string
  postfix?: string
}

export default function TextInputGroup(props: TextInputProps) {
  const {id, value, prefix, postfix, label, validationError, className, onChange, placeholder} = props
  const disabled = boolOr(props.disabled, false)
  const [isLoading, setIsLoading] = useState(false)
  
  function handleChange(e: SyntheticEvent<HTMLInputElement>) {
    const response = onChange(e.currentTarget.value)
    const promise = asPromise(response)
    if (promise) {
      setIsLoading(true)
      promise
        .then(() => setIsLoading(false))
        .catch(() => setIsLoading(false))
    }
  }
  
  return <FlexContainer className="text-input-group" vertical>
    {hasText(label) &&
      <label htmlFor={id} className="form-label">{label}</label>
    }
    <div 
      className={classNames("input-group", className, {
        "has-validation": hasText(validationError)
      })}
    >
      {hasText(prefix) &&
        <span className="input-group-text" id={`${id}_prefix`}>{prefix}</span>
      }  
      <input 
        type="text" 
        className={classNames("form-control", {
          "is-invalid": hasText(validationError)
        })} 
        id={id} 
        value={value}
        placeholder={placeholder}
        onChange={handleChange}
        aria-describedby={
          hasText(prefix) 
            ? `${id}_prefix`
            : hasText(postfix)
              ? `${id}_postfix`
              : undefined
        }
        disabled={disabled || isLoading}
        autoFocus={true}
      />
      {hasText(postfix) &&
        <span className="input-group-text" id={`${id}_postfix`}>{postfix}</span>
      }
    </div>
    {hasText(validationError) &&
      <div className="invalid-feedback">
        {validationError}
      </div>
    }
  </FlexContainer>  
}

